export const ComplexSalesBusinessTypes = ['manufacture', 'services', 'other']

export const ONBOARDING_CHECKLIST = [
  { id: 'registration', completed: true },
  { id: 'complexSale', completed: false, condition: (businessType) => {
    return ComplexSalesBusinessTypes.includes(businessType.id)
  } },
  { id: 'sale', completed: false, condition: (businessType) => {
    return !ComplexSalesBusinessTypes.includes(businessType.id)
  } },
  { id: 'saleReport', completed: false },
  { id: 'productStock', completed: false },
  { id: 'complexSaleHistory', completed: false, condition: (businessType) => {
    return ComplexSalesBusinessTypes.includes(businessType.id)
  } },
  { id: 'saleHistory', completed: false, condition: (businessType) => {
    return !ComplexSalesBusinessTypes.includes(businessType.id)
  } },
  { id: 'createProduct', completed: false },
  { id: 'createSupply', completed: false },
  { id: 'createSpending', completed: false },
  { id: 'profitReport', completed: false },
  { id: 'viewModules', completed: false },
  { id: 'viewHelp', completed: false },
  { id: 'viewWeb', completed: false },
]